var _desc, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLifetaskLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 160,
    height: 128,
    viewBox: "0 0 1280 1024",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.3.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5 0 0 5 640 512)",
    id: "logo-logo"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    paintOrder: "stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.2061547460355993 0 0 -0.20615474603559933 4.039571860669071 -38.246958705537224)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(49,181,221)",
      fillRule: "nonzero",
      opacity: 1
    },
    paintOrder: "stroke",
    transform: " translate(-989.3535, -651.8965000000001)",
    d: "M 989.355 573.563 C 946.0740000000001 573.563 911.047 608.645 911.047 651.891 C 911.047 695.18 946.0740000000001 730.23 989.355 730.23 C 1032.6200000000001 730.23 1067.66 695.1800000000001 1067.66 651.8910000000001 C 1067.66 608.6450000000001 1032.6200000000001 573.5630000000001 989.355 573.5630000000001",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.2061547460355993 0 0 -0.20615474603559933 -30.535155983826428 -54.35156131109218)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(31,155,193)",
      fillRule: "nonzero",
      opacity: 1
    },
    paintOrder: "stroke",
    transform: " translate(-821.641, -730.0155)",
    d: "M 821.727 730.23 C 821.688 730.082 821.621 729.938 821.555 729.801 C 821.555 729.801 821.5659999999999 729.855 821.5659999999999 729.883 C 821.637 729.988 821.6759999999999 730.105 821.7269999999999 730.23",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.2061547460355993 0 0 -0.20615474603559933 -4.267721862803114 -59.63510492732888)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(31,155,193)",
      fillRule: "nonzero",
      opacity: 1
    },
    paintOrder: "stroke",
    transform: " translate(-949.0571018659608, -755.6445176085701)",
    d: "M 747.059 789.742 C 777.1949999999999 877.805 843.355 930.02 941.477 932.66 C 1078.06 936.3439999999999 1156.3 814.9019999999999 1167.01 779.3589999999999 C 1158.47 805.43 1077.48 861.1949999999999 983.7339999999999 865.039 C 870.406 869.691 731.4259999999999 773.43 754.8789999999999 578.547 C 721.5779999999999 651.195 727.406 732.297 747.0589999999999 789.742",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.2061547460355993 0 0 -0.20615474603559933 25.204311779975967 61.949917123279874)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(49,181,221)",
      fillRule: "nonzero",
      opacity: 1
    },
    paintOrder: "stroke",
    transform: " translate(-1092.017835050778, -165.869)",
    d: "M 1005.57 265.527 C 1180.31 117.551 1161 25.5078 1150.45 0 C 1204.66 108.281 1177.94 224.766 1089.81 331.738 C 1076.21 319.855 1061.74 308.223 1046.36 296.93399999999997 C 1032 286.39799999999997 1018.4399999999999 275.92999999999995 1005.5699999999999 265.527",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.2061547460355993 0 0 -0.20615474603559933 -19.275048640221485 -22.169259294339867)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(49,181,221)",
      fillRule: "nonzero",
      opacity: 1
    },
    paintOrder: "stroke",
    transform: " translate(-876.2606852613833, -573.908)",
    d: "M 885.137 363.074 C 922.0899999999999 398.645 956.6719999999999 429.16 974.223 444.59000000000003 C 751.141 656.879 851.57 784.742 851.57 784.742 C 737.844 692.527 762.242 479.895 885.137 363.074",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.2061547460355993 0 0 -0.20615474603559933 6.455540766262516 17.575050006556268)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(31,155,193)",
      fillRule: "nonzero",
      opacity: 1
    },
    paintOrder: "stroke",
    transform: " translate(-1001.0727009985366, -381.11928149999994)",
    d: "M 1034.19 313.516 C 1010.2700000000001 295.957 989.07 279.063 970.25 262.84400000000005 L 970.25 262.85900000000004 C 796.461 115.684 811.031 26.4844 821.566 0.398438 L 821.566 0.351563 C 767.656 108.43 794.297 224.648 882.117 331.426 C 882.211 331.52299999999997 882.309 331.609 882.414 331.719 C 937.2189999999999 385.84 992.074 432.605 999.145 439.15999999999997 C 1230.8899999999999 653.691 1104.93 761.887 1104.93 761.887 C 1294.23 618.4219999999999 1195.69 432.1019999999999 1034.19 313.51599999999996",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifetaskLogoSmall);
export default __webpack_public_path__ + "static/media/lifetask_logo_small.07abfca32ba645d2ea68ec971c95bbfd.svg";
export { ForwardRef as ReactComponent };